// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__JVpyK","subContainer":"Modal_subContainer__l8SQ5","header":"Modal_header__3iwKg","closeButton":"Modal_closeButton__0B2i1"};